export default __webpack_public_path__ + "static/media/google-revenue.50a0e3db.svg";